import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Router } from '@angular/router';
import { ServerapiService } from 'src/app/serverapi.service';
import { Configuration } from 'src/app/app.constants';
import { AppComponent } from 'src/app/app.component';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private serverapi: ServerapiService,
    private configuration: Configuration,
    private appComponent: AppComponent,
    private subscriptionService: SubscriptionService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    document.documentElement.scrollTop = 0
  }
isDropdownOpen = false;

scrollToSection(sectionId: string) {
  this.isDropdownOpen = false; // close dropdown first

  setTimeout(() => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 100);
}

ngAfterViewInit() {
  this.route.fragment.subscribe(fragment => {
    if (fragment) {
      setTimeout(() => {
        const element = document.getElementById(fragment);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  });
}
}
